'use strict';

module.exports = require('./lib/React');



//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/react/react.js
// module id = 1
// module chunks = 4 5 6 7 8 9 10 11 12